var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.177,
    height: 58.831,
    viewBox: "0 0 54.177 58.831",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mail-symbol",
    d: "M1.671,21.1,27.548,0,52.315,21.1ZM24.5,28.281a1.455,1.455,0,1,1,0-2.911h4.026a1.455,1.455,0,1,1,0,2.911Zm11.49,0a1.455,1.455,0,1,1,0-2.911h5.779a1.455,1.455,0,0,1,0,2.911Zm-23.747,0a1.455,1.455,0,1,1,0-2.911h5.779a1.455,1.455,0,0,1,0,2.911Zm11.313,7.4a1.455,1.455,0,1,1,0-2.911h6.88a1.455,1.455,0,1,1,0,2.911ZM0,56.6l18.432-18.48L0,23.1V56.609ZM20.462,39.781l-19,19.05h51.1L34.4,39.781l-5.989,5.1h0a1.3,1.3,0,0,1-1.666,0Zm15.924-1.69L54.177,56.762V22.933Z",
    fill: "#5bb974"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.192822c642ed14d3f581f84d614d37f6.svg";
export { ForwardRef as ReactComponent };